import React from "react";
import SharedLayout from "./SharedLayout";
import "./PeopleView.css";
import "../styles/PageWrappers.css";

const PeopleView = ({ user, onLoginClick }) => {
  return (
    <SharedLayout user={user} onLoginClick={onLoginClick}>
      <div className="people-wrapper">
        <h1
          style={{
            textAlign: "center",
            marginBottom: "2rem",
            color: "#2c3e50",
            fontSize: "2rem",
          }}
        >
          People
        </h1>

        <div className="people-content">
          <section className="intro-section">
            <h2>
              The <span className="sigmund-text">Sigmund</span> Project:
              Collaborative, Multidisciplinary Development Driven by Expertise
              and Innovation
            </h2>
            <p>
              The development of <span className="sigmund-text">Sigmund</span>{" "}
              was a truly global and multidisciplinary effort, with numerous
              experts contributing from various fields and corners of the world.
              The project drew upon the knowledge and skills of individuals from
              administration, financing, algorithm development, programming,
              data science, and testing. A critical component of the project's
              success was the collection of personal, consistent, de-identified
              data from participants across diverse demographics, which helped
              ensure a comprehensive and representative reference dataset.
            </p>
          </section>

          <section className="collaboration-section">
            <h3>Expert Collaboration</h3>
            <p>
              A significant number of psychiatric professionals were involved,
              offering their expertise in the form of relevance-scoring of
              mental condition-related questions/answers, and diagnoses of
              mental health conditions for a significant portion of the
              project's participants. Most of these experts did not know each
              other. This "anonymized" collaborative approach was designed to
              ensure the project remained as unbiased and distributed as
              possible. The aim was to gather diverse perspectives while
              avoiding any potential for undue influence or preconceptions in
              the development process.
            </p>
          </section>

          <section className="leadership-section">
            <h3>Project Leadership</h3>
            <div className="leader-profile">
              <h4>James Durward</h4>
              <p className="leader-title">Project Originator and Lead</p>
              <p>
                At the helm of <span className="sigmund-text">Sigmund</span> is
                James Durward, the originator and driving force behind the
                project. With extensive experience in both business and
                technology (including AI/machine-learning), James has played a
                central role in every aspect of{" "}
                <span className="sigmund-text">Sigmund's</span> creation.
              </p>
              <div className="expertise-areas">
                <h5>Areas of Expertise:</h5>
                <ul>
                  <li>Custom database architecture</li>
                  <li>Image analysis</li>
                  <li>Pattern recognition algorithms</li>
                  <li>Product conceptualization and development</li>
                </ul>
              </div>
              <p className="achievements">
                James holds multiple patents, including innovations in
                three-dimensional, multi-user voice processing and advanced
                thermodynamic extraction technologies, demonstrating a deep
                understanding of complex systems and cutting-edge technology.
              </p>
              <p className="project-info">
                <span className="sigmund-text">Sigmund</span> was developed over
                a four-year period at a multi-million dollar cost.
              </p>
            </div>
          </section>
        </div>
      </div>
    </SharedLayout>
  );
};

export default PeopleView;
